import Dropdown from '@components/ProductComparison/_Dropdown';
import Product from '@models/product';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  selectedSkus: (string | '')[];
  selectableProducts: Product[];
  updateSelectedProducts: (sku: string, index: number) => void;
  asContentRow?: boolean;
  className?: string;
}

const DropdownWrapper = ({
  asContentRow,
  selectedSkus,
  selectableProducts,
  updateSelectedProducts,
}: Props) => {

  return (
    <div className={classNames(
      "tw-grid tw-bg-white tw-px-1 sm:tw-px-6 tw-pt-4 tw-gap-1 sm:tw-gap-6 tw-pb-2 tw-w-full tw-z-50 tw-sticky tw-top-[calc(var(--navTop)_+_var(--sticky-nav-height))]",
      asContentRow ? "tw-grid-cols-2 md:tw-hidden" : "tw-grid-cols-2 md:tw-grid-cols-4",
    )}>
      <div className="tw-hidden md:tw-block" />
      {selectedSkus.map((sku, i) => {
        return (
          <div className="tw-flex tw-flex-col tw-text-center tw-h-full" key={sku}>
            <Dropdown
              sku={sku}
              products={selectableProducts}
              updateSelectedProducts={updateSelectedProducts}
              index={i}
              className="tw-block"
            />
          </div>
        );
      })}
    </div>
  );
};

export default DropdownWrapper;
